import ProCard from './ProCard';
import ProsList from './ProsList';
import ProPage from './ProPage';

export default {
  ProCard,
  ProsList,
  ProPage,
}


// WEBPACK FOOTER //
// ./src/modules/pros/components/index.js